import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { StorybookModule } from '@app/storybook/storybook.module';
import { RuleTemplateSelectorComponent } from './components/rule-template/rule-template-selector.component';
import { OrderCreatedTemplateComponent } from './components/rule-template/order-created/order-created-template.component';
import { OrderAssignedTemplateComponent } from './components/rule-template/order-assigned/order-assigned-template.component';
import { OrderFulfilledTemplateComponent } from './components/rule-template/order-fulfilled/order-fulfilled-template.component';
import { SharedModule } from '../../sharedModule/shared.module';
import { RulesListComponent } from './components/rules-list/rules-list.component';
import { AutomationRulesListDialog } from './components/dialog/list/automation-rules-list-dialog';
import { AutomationRuleCreateDialog } from './components/dialog/create/automation-rule-create-dialog';
import { AutomationRuleEditDialog } from './components/dialog/edit/automation-rule-edit-dialog';
import { AutomationRulesEffects } from './effects';
import { AutomationRulesReducer } from './reducers';
import { LoopNumber } from '@app/core/services/utils/util.service';
import { RelativeDaysComponent } from './components/rule-template/relative-days/relative-days.component';
import { SplitOrderRuleComponent } from './components/rule-template/split-order-rule/split-order-rule.component';
import { OrderTrackedTemplateComponent } from './components/rule-template/order-tracked/order-tracked-template.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    SharedModule,
    StorybookModule,
    StoreModule.forFeature(AutomationRulesReducer.featureKey, AutomationRulesReducer.reducer),
    EffectsModule.forFeature([AutomationRulesEffects]),
  ],
  declarations: [
    RuleTemplateSelectorComponent,
    OrderCreatedTemplateComponent,
    OrderAssignedTemplateComponent,
    OrderFulfilledTemplateComponent,
    OrderTrackedTemplateComponent,
    RulesListComponent,
    AutomationRulesListDialog,
    AutomationRuleCreateDialog,
    AutomationRuleEditDialog,
    LoopNumber,
    RelativeDaysComponent,
    SplitOrderRuleComponent,
  ],
  exports: [
    RuleTemplateSelectorComponent,
    RulesListComponent,
    AutomationRulesListDialog,
    AutomationRuleCreateDialog,
    AutomationRuleEditDialog,
    LoopNumber,
  ],
})
export class AutomationRulesFeatureModule {}
